const $win = $(window);
const $doc = $(document);
var isAjax = false;

$( '.section-blog' ).on( 'click', '.section__actions a.btn--ajax', function( e ) {
	e.preventDefault();

	if ( isAjax ) {
		return;
	}

	let _this = $( this );
	let $container = _this.closest( '.section-blog' );

	$.ajax({
		url: _this.attr( 'href' ),
		beforeSend: function () {
			isAjax = true;	
			_this.addClass( 'is-ajax' );
		},
		success: function ( response ) {
			let containerClass = '.section-blog .section__body .list-articles';
			let pagingClass = '.section-blog .section__actions';
			let $results = $( response ).find( containerClass );
			let $paging = $( response ).find( pagingClass );

			if ( $results.length ) {
				$( containerClass ).append( $results.html() );
			}

			if ( $paging ) {
				$( pagingClass ).replaceWith( $paging );
			} else {
				$( pagingClass ).remove();
			}
		},
		complete: function () {
			isAjax = false;	
			_this.removeClass( 'is-ajax' );
		}
	});
});

